export default "__VITE_ASSET__Dqnmtodg__"